import { StatementProps } from 'modules/clients/types/client.types';
import TransactionDetailDropdown from './transaction-detail-dropdown/TransactionDetailDropdown';
import { getTransactionDetailReport } from 'bff/hooks/reporting/TransactionDetailApi';
import { useSuspenseQuery } from '@tanstack/react-query';
import { SomethingWentWrong } from 'modules/app/components/pages/something-went-wrong/SomethingWentWrong';
import { Suspense } from 'react';

export const TransactionDetailStatement = ({
  clientId,
  formValues,
  startDate,
  endDate
}: StatementProps) => {
  const invNum = formValues.investments[0]?.investmentPlanNumber;
  const { data } = useSuspenseQuery(getTransactionDetailReport(invNum, clientId));

  if (data === undefined) {
    return <SomethingWentWrong />;
  }
  return (
    <Suspense>
      <TransactionDetailDropdown transactionDetail={data} startDate={startDate} endDate={endDate} />
    </Suspense>
  );
};
